import React from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import H1 from "../Atoms/H1";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ImageBox from "../Atoms/ImageBox";
import Section from "../Atoms/Section";
import UppercaseInfo from "../Atoms/UppercaseInfo";
import BoldBlue from "../Atoms/BoldBlue";
import CityCommaCountry from "../Utils/CityCommaCountry";
import Spinner from "../../Plateforme/Atoms/Spinner";
import Miniature from "../Atoms/Miniature";
import MiniatureContainer from "../Atoms/MiniatureContainer";
import Collaborators from "../Components/Collaborators";
import GetProjectMainImage from "../Utils/GetProjectMainImage";
import AwardsDisplay from "../Atoms/AwardsDisplay";
import Events from "../Atoms/Events";
import SocialNetworksDisplay from "../Atoms/SocialNetworksDisplay";
import FormatActivité from "../Utils/FormatActivité";
import link from "../Utils/Format";
import DateAdhésion from "../Atoms/DateAdhésion";
import Text10LinesMax from "../Atoms/Text10LinesMax";
import DefaultCompanyCover from "../Utils/DefaultCompanyCover";
import { userHasFullAccess } from "../Utils/Validator";
import NoAccessPlaceholder from "../Atoms/NoAccessPlaceholder";
import H0 from "../Atoms/H0";
import { positionnements, clientèles } from "../Utils/Listings";
import { createUrlWithRedirect } from "../Utils/redirectUtils";

const Company = (props) => {

    const [company, setCompany] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const [owner, setOwner] = React.useState({});
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const public_view = urlParams.get('public_view') === "1";
    const [fullAccess, setFullAccess] = React.useState(false);

    React.useEffect(() => {
        setFullAccess((props.fullUser?.user?._id === owner?.user?._id) || userHasFullAccess(props.fullUser, props.fullUserLoading) || public_view);
    }, [props.fullUser, props.fullUserLoading, owner]);


    React.useEffect(() => {
        if(!id) {
            navigate(createUrlWithRedirect('/login', location.pathname + location.search));
            return;
        };
        api.GetAllCompanyData({id}).then((response) => {
            // console.log(response.data);
            setCompany(response.data);
            api.GetCollaborators({hubspotID : response.data.company.hubspotID}).then((_response) => {
                // console.log(_response.data);
                const _owner = _response.data.find((collaborator) => collaborator.user._id === response.data.company.ownerUserId);
                // console.log("_owner :");
                // console.log(_owner);
                setOwner(_owner);
                setLoading(false);
            }).catch((error) => {
                console.log(error);
            });
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }, [id,navigate]);

    const dateToYear = (date) => {
        if(!date) return "";
        return date.split("-")[0];
    }

    if(loading){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
            </>
        )
    }

    const properties = company.hsCompany?.properties;
    const publicProjects = company.company.projects && company.company.projects.filter((project) => project.public);
    const activitéEntreprise = properties?.cat_gories_via || owner?.hsProfile?.properties?.cat_gories_via || "";

    const parseSemiColonSeparatedValues = (value) => {
        if(!value) return "";
        return value.split(";").filter(_value => _value).join(", ");
    }

    return (
        <div>
            <Section>
                <ImageBox
                    currentImagePath={company.company?.cover_picture ? (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + company.company?.cover_picture) : DefaultCompanyCover(company.company)}
                    width="100%"
                    height="400px"
                />
            </Section>
            <Section className="padding flexblock" style={{alignItems:'center'}}>
                <H0>{properties?.name?.toUpperCase()}</H0>
                {props.fullUser?.user?._id === company.company.ownerUserId && 
                    <BoldBlue onClick={() => navigate('/mycompany')} style={{display:"inline-block", cursor:'pointer'}}>
                        <img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Aperçu en mode public" : "Preview in public mode"}
                    </BoldBlue>
                }
            </Section>
            {(activitéEntreprise || properties?.savoir_faire || properties?.secteur) && <Section className="padding">
                {activitéEntreprise && <><UppercaseInfo>{i18n.language === "fr" ? "Activité de l'entreprise :" : "Company activity:"}</UppercaseInfo> <UppercaseInfo className="blue">{FormatActivité(activitéEntreprise, i18n.language)}</UppercaseInfo><br/></>}
                {properties?.savoir_faire && <><UppercaseInfo>{i18n.language === "fr" ? "Savoir faire :" : "Know-how:"}</UppercaseInfo> <UppercaseInfo className="blue">{parseSemiColonSeparatedValues(properties?.savoir_faire)}</UppercaseInfo><br/></>}
                {properties?.secteur && <><UppercaseInfo>{i18n.language === "fr" ? "Secteur :" : "Sector:"}</UppercaseInfo> <UppercaseInfo className="blue">{parseSemiColonSeparatedValues(properties?.secteur)}</UppercaseInfo><br/></>}
                <DateAdhésion date={owner?.hsProfile?.properties?.date_adhesion_club_le_french_design}/>
            </Section>}
            <Section className="flexblock">
                <div style={{flex:'2'}}>
                    <div className="flexblock" style={{alignItems:"flex-start"}}>
                        <div>
                            {company.hsCompany?.properties?.date_de_creation_de_l_entreprise && <><BoldBlue>{i18n.language === "fr" ? "Année de création" : "Year of creation"}</BoldBlue><br/>{fullAccess ? <span>{dateToYear(company.hsCompany?.properties?.date_de_creation_de_l_entreprise)}</span> : <NoAccessPlaceholder/>}<br/><br/></>}
                            <BoldBlue>Contact</BoldBlue><br/>
                            {fullAccess ? (company.hsCompany?.properties?.work_email && <span>{company.hsCompany?.properties?.work_email}<br/></span>) : <><NoAccessPlaceholder/><br/></>}
                            {fullAccess ? (company.hsCompany?.properties?.phone && <span>{company.hsCompany?.properties?.phone}<br/></span>) : <><NoAccessPlaceholder/><br/></>}
                            <br/>
                            {(company.hsCompany?.properties?.address || CityCommaCountry(company.hsCompany?.properties)) && <>
                                <BoldBlue>{i18n.language === "fr" ? "Adresse" : "Address"}</BoldBlue><br/>
                                {company.hsCompany?.properties?.address && <span>{company.hsCompany?.properties?.address}<br/></span>}
                                {CityCommaCountry(company.hsCompany?.properties) && <span>{CityCommaCountry(company.hsCompany?.properties)}<br/></span>}
                                <br/>
                            </>}
                            {fullAccess ? <Events events={owner?.hsProfile?.properties?.events}/> : <><BoldBlue>{i18n.language === "fr" ? "Participations" : "Participations"}</BoldBlue><br/><NoAccessPlaceholder/></>}
                            <br/><br/>
                        </div>
                        <div>
                            {company.hsCompany?.properties?.email_agence_rp && <>
                                <BoldBlue>{i18n.language === "fr" ? "Presse" : "Press"}</BoldBlue><br/>
                                {fullAccess ? <span>{company.hsCompany?.properties?.email_agence_rp}</span> : <NoAccessPlaceholder/>}<br/><br/>
                            </>}
                            <BoldBlue>{i18n.language === "fr" ? "Clientèle" : "Customer base"}</BoldBlue><br/>
                            {fullAccess ? <span>{company.hsCompany?.properties?.clientele && company.hsCompany?.properties?.clientele.split(';').map(cli => {
                                const trimmedCli = cli.trim();
                                const matchingCli = clientèles.find(c => c.code === trimmedCli);
                                return matchingCli ? (i18n.language === "fr" ? matchingCli.fr : matchingCli.en) : trimmedCli;
                            }).join(', ')}</span> : <NoAccessPlaceholder/>}<br/><br/>
                            <BoldBlue>{i18n.language === "fr" ? "Positionnement" : "Positioning"}</BoldBlue><br/>
                            {fullAccess ? <span>{company.hsCompany?.properties?.positionnement && company.hsCompany?.properties?.positionnement.split(';').map(pos => {
                                const trimmedPos = pos.trim();
                                const matchingPos = positionnements.find(p => p.code === trimmedPos);
                                return matchingPos ? (i18n.language === "fr" ? matchingPos.fr : matchingPos.en) : trimmedPos;
                            }).join(', ')}</span> : <NoAccessPlaceholder/>}<br/><br/>
                            {/*Temporarily hidden*/false && company.hsCompany?.properties?.annualrevenue && company.hsCompany?.properties?.annualrevenue != 0 && <><BoldBlue>{i18n.language === "fr" ? "Chiffre d'affaires" : "Annual revenue"}</BoldBlue><br/>
                            {/*Temporarily hidden*/false && fullAccess ? <span>{company.hsCompany?.properties?.annualrevenue} €</span> : <NoAccessPlaceholder/>}<br/><br/></>}
                            {company.hsCompany?.properties?.numberofemployees && company.hsCompany?.properties?.numberofemployees != 0 && <>
                                <BoldBlue>{i18n.language === "fr" ? "Nombre d'employés" : "Number of employees"}</BoldBlue><br/>
                                {fullAccess ? <span>{company.hsCompany?.properties?.numberofemployees}</span> : <NoAccessPlaceholder/>}<br/><br/>
                            </>}
                        </div>
                    </div>
                    <div className="flexblock">
                        {company.hsCompany?.properties?.website && <span style={{flex:"none"}}>
                            <a href={link(company.hsCompany?.properties?.website)} target="_blank" rel="noreferrer">
                                <BoldBlue style={{display:"inline-block"}}><img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Site internet" : "Website"}</BoldBlue>
                            </a>
                        </span>}
                        <SocialNetworksDisplay
                            twitter={company.hsCompany?.properties?.twitterhandle}
                            instagram={company.hsCompany?.properties?.compte_instagram}
                            linkedin={company.hsCompany?.properties?.linkedin_company_page}
                        />
                    </div>
                    <div className="flexblock">
                        {company.hsCompany?.properties?.lien_catalogue_3d && <span style={{flex:"none"}}>
                            <a href={link(company.hsCompany?.properties?.lien_catalogue_3d)} target="_blank" rel="noreferrer">
                                <BoldBlue style={{display:"inline-block"}}><img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Fichiers 3D" : "3D Files"}</BoldBlue>
                            </a>
                        </span>}
                    </div>
                </div>
                <div>
                    {fullAccess ? <Collaborators readonly company={company} publicView={public_view}/> : <><BoldBlue>{i18n.language === "fr" ? "Collaborateurs" : "Partners"}</BoldBlue><br/><NoAccessPlaceholder/><br/><br/></>}
                    {fullAccess ? <AwardsDisplay awards={company.hsCompany?.properties?.awards} /> : <><BoldBlue>{i18n.language === "fr" ? "Awards" : "Awards"}</BoldBlue><br/><NoAccessPlaceholder/></>}
                    <br/><br/>
                    <p style={{fontSize:"12px",color:"#aaa"}}>
                        {company.company.coverCredit && <>{i18n.language === "fr" ? "Photo de couverture :" : "Cover picture:"} {company.company.coverCredit}<br/></>}
                    </p>
                </div>
                <div style={{borderLeft:"1px solid black",paddingLeft:"20px"}}>
                    <ImageBox
                        currentImagePath={company.company?.logo && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + company.company?.logo)}
                        width="400px"
                        height="400px"
                        objectFit="contain"
                    />
                    {company.company.logoCredit && <p style={{fontSize:"12px",color:"#aaa",textAlign:"center",marginTop:'5px'}}>
                        {i18n.language === "fr" ? "Crédit :" : "Credit:"} {company.company.logoCredit}<br/>
                    </p>}
                </div>
            </Section>
            <Section className="padding">
                <H2>{i18n.language === "fr" ? "À PROPOS" : "ABOUT"}</H2>
            </Section>
            <Section className="padding">
                <Text10LinesMax>{i18n.language === "fr" ? company.hsCompany?.properties?.description_courte_fr : company.hsCompany?.properties?.description_courte_en}</Text10LinesMax>
            </Section>
            {publicProjects && publicProjects.length > 0 && <>
                <Section className="padding">
                    <H1>{i18n.language === "fr" ? "PROJETS" : "PROJECTS"}</H1>
                </Section>
                <Section className="padding">
                    {fullAccess ? <MiniatureContainer>
                        {publicProjects.map((project) => {
                            if(project.type === "objet") return (
                                <Link to={"/project?pid=" + project._id + "&cid=" + company.company?._id + (public_view ? "&public_view=1" : "")} key={project._id}>
                                    <Miniature
                                        imagePath={GetProjectMainImage(project)}
                                        title={project.name}
                                        tag={i18n.language === "fr" ? "Projet" : "Project"}
                                        //no privacy
                                        keyInfo={project.adresse}
                                        category={project.libre_edition === "oui" ? (i18n.language === "fr" ? "Libre à l'édition" : "Free to edit") : project.editeur}
                                    />
                                </Link>
                            ); return (
                                <Link to={"/project?pid=" + project._id + "&cid=" + company.company?._id + (public_view ? "&public_view=1" : "")} key={project._id}>
                                    <Miniature
                                        imagePath={GetProjectMainImage(project)}
                                        title={project.name}
                                        tag={i18n.language === "fr" ? "Projet" : "Project"}
                                        //no privacy
                                        keyInfo={project.adresse}
                                        category={project.fabrication_fr === "oui" ? (i18n.language === "fr" ? "Fabrication française" : "French manufacturing") : null}
                                    />
                                </Link>
                            );
                        })}
                    </MiniatureContainer> : <NoAccessPlaceholder style={{height:'400px'}}/>}
                </Section>
            </>}
        </div>
    );
};

export default Company;